import { LoadingOutlined, MinusOutlined } from '@ant-design/icons';
import { HTMLAttributes, memo } from 'react';
import { useTranslate } from '@tolgee/react';

interface LoadMoreFooterProps extends HTMLAttributes<HTMLDivElement> {}

export const LoadingMoreFooter = memo((props: LoadMoreFooterProps) => {
  const { t } = useTranslate();

  return (
    <div className="flex items-center justify-center h-8 gap-2" {...props}>
      <LoadingOutlined />
      <span className="text-content-200">{t('loadMore.loading')}</span>
    </div>
  );
});

export const NoMoreFooter = memo((props: LoadMoreFooterProps) => {
  const { t } = useTranslate();
  return (
    <div className="flex items-center justify-center h-8 gap-2" {...props}>
      <MinusOutlined className="text-content-200" />
      <span className="text-content-200">{t('loadMore.noMore')}</span>
      <MinusOutlined className="text-content-200" />
    </div>
  );
});

export const LoadErrorFooter = memo((props: LoadMoreFooterProps) => {
  const { t } = useTranslate();
  return (
    <div className="flex items-center justify-center h-8 gap-2" {...props}>
      <MinusOutlined className="text-content-200" />
      <span className="text-content-200 cursor-pointer">{t('loadMore.error')}</span>
      <MinusOutlined className="text-content-200" />
    </div>
  );
});
